import gql from "graphql-tag";
import PinnablePostFields from "../../fragments/engagement/PinnablePostFields";

export default gql`
  mutation PinPostReply($replyId: ObjectID!) {
    pinPostReply(replyId: $replyId) {
      ...PinnablePostFields
    }
  }

  ${PinnablePostFields}
`;
